// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pYq2","toggle":"styles_toggle__jmFza","preview":"styles_preview__3hkV9"};